var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("iframe", {
      staticClass: "iframe-player",
      attrs: {
        src:
          "https://view.officeapps.live.com/op/embed.aspx?src=" +
          encodeURIComponent(_vm.file_url)
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }